import React, { useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";
import { MdArrowForwardIos, MdClose } from "react-icons/md";
import Slider from "react-slick";
import subscriptions from "./data";
import { getAccessToken } from "../../../services/authService";
import { useState } from "react";
import LoaderSpin from "../../Common/LoaderSpin";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import SubscriptionModal from "./SubscriptionModal";

const Subscription = ({ close }) => {

  const settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    gap: 20,
    responsive: [
      {
        breakpoint: 1145,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userObj = JSON.parse(user);
      const activePlan = userObj.subscription.plan;
      const plans = ["Free", "Freemium", "Essential", "Professional"];

      // Find the index of the active plan
      const activeIndex = activePlan==='Essential with Alex AI'? plans.indexOf('Essential')
      : activePlan==='Professional with Alex AI'? plans.indexOf('Professional')
      : plans.indexOf(activePlan);


      // Iterate through each plan and update the button text
      subscriptions.forEach((plan, index) => {

        if (index < activeIndex) {
          // For previous plans
          plan.btnText = 'Proceed';
          plan.btnShowArrow = true
        } else if (index > activeIndex) {
          // For next plans
          plan.btnText = 'Proceed';
          plan.btnShowArrow = true
        } else {
          // For the active plan
          plan.btnText = 'Current Plan';
          plan.btnShowArrow = false
        }

        if (plan.title === "Free" && index < activeIndex) {
          plan.btnText = 'Expired';
          plan.isDisabled = true;
          plan.btnShowArrow = false  // Disable the button if the active plan is above "Free"
        }
      });

    }
  }

    , []);

  return (
    <div className="h-full  mx-2 flex flex-col lg:max-w-[90vw] mx-auto">
      <div className="flex gap-2 m-4 items-center justify-between ">
        <Link to={"/myprofile"} className="lg:hidden">
          <IoIosArrowBack size={24} color="#292929" />
        </Link>
        <h1 className="grow lg:text-[28px] text-[#292929] font-[700] lg:text-center lg:my-4">
          Change your plan
        </h1>
        {close && (
          <button onClick={close}>
            <MdClose size={24} />
          </button>
        )}
      </div>
      <hr className="lg:hidden w-full" />

      <div className="overflow-x-hidden overflow-y-auto px-6 py-4">
        <Slider {...settings}>
          {subscriptions.map((s, key) => (
            <SubscriptionCard key={key} info={s} />
          ))}
        </Slider>
      </div>
    </div>
  );
};

const SubscriptionCard = ({ info }) => {
  const [loading, setLoading] = useState(false);
  const [openPlanModal, setOpenPlanModal] = useState(false);

  const createCustomerPortalSession = async () => {
    setLoading(true);
    try {
      const token = getAccessToken();
      const response = await fetch(
        `${process.env.REACT_APP_DEV_API}/payment/create-customer-portal-session`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      window.open(data.url, "_blank");
      // navigate("/scripts");
      setLoading(false);
    } catch (error) {
      console.error("Error creating customer portal session:", error);
    }
  };

  const handleClick = (type) => {
    if(type === 'Essential' || type === 'Professional'){
      setOpenPlanModal(true)
      return
    }   

    createCustomerPortalSession();
  };

  return (
    <div  className="flex flex-col p-4 max-w-md text-center text-gray-900 bg-white rounded-lg border shadow md:shadow-none h-[1000px]">
      <SubscriptionModal plan={info} openEssentialModal={openPlanModal} setOpenEssentialModal={setOpenPlanModal} createCustomerPortalSession={createCustomerPortalSession}/>

      <div className="h-fit max-lg:min-h-[300px]">
        <h3 style={{ background: info.background }} className="mb-4 p-4 rounded-lg text-2xl font-semibold text-white ">{info.title}</h3>
        <p className="font-light text-gray-500 sm:text-base lg:h-[80px] md:h-[88px] pb-4"> 
          {info.description}
        </p>
        <hr style={{borderColor:info.background}} className="my-4 max-md:mt-0"/>
        
        {info.price != "0" && (
          <>
            <div className="flex justify-center items-baseline mb-8">
              <span className="mr-2 text-5xl font-extrabold max-lg:text-2xl">${info.price}</span>
              <span className="text-gray-500">/month</span>
            </div>
            <p className="-mt-4 text-[14px] mb-[14px] text-gray-500">12  Month Contract Billed Monthly</p>
          </>
        )}
        {info.title == "Free" && (
          <>
          <h3 className="mr-2 text-3xl max-lg:text-xl font-extrabold my-10 text-sky-500">
            14 Days Free
          </h3>
          </>
        )}
        {info.title == "Freemium" && (
          <>
          <h3 className="mr-2 text-3xl max-lg:text-xl font-extrabold my-10 text-sky-500">
            Free for Ever
          </h3>
          </>
        )}
        <hr className="border-b"/>
      </div>

      <button
        onClick={()=>{handleClick(info.title)}}
        disabled={info.btnText === "Current Plan" || info.isDisabled}
        // disabled={info.btnText == "Current plan"}
        type={info.btnText == "Current plan" ? "light" : ""}
        className="w-full flex items-center justify-center rounded-full bg-[#0ea5e9] p-4 mt-3 text-white text-[16px] disabled:bg-[#f5f5f5] disabled:text-[#a3a3a3] font-bold"
      >
        {loading ?
          <LoaderSpin color={"white"} size={24} /> :
          <div className="flex items-center w-full ">
            <p className="grow w-full">{info.btnText} </p>
            {info.btnShowArrow && <MdArrowForwardIos size={24} />}
          </div>}
      </button>

      <ul role="list" className="mb-8 space-y-4 text-left mt-6 text-sm">
        {info.features.map((item, index) => (
          <li key={index} className="flex items-center space-x-3">
            {item.available ? (
              <svg
                className="flex-shrink-0 w-5 h-5 text-green-500"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg
                class="w-[20px] h-[20px] text-red-600"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
            )}
            <span>{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};



export default Subscription;
